/* global StripeCheckout */
import React, { Component } from 'react'
import moment from 'moment'
import InstallGuide from './InstallGuide'
import { get, post } from './util'
import Button from './components/Button'
import Panel from './components/Panel'
import Modal from './components/Modal'

const getQueryVariable = variable => {
  const query = window.location.search.substring(1)
  const vars = query.split('&')
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=')
    if (decodeURIComponent(pair[0]) === variable) {
      return decodeURIComponent(pair[1])
    }
  }
  return null
}

class Landing extends Component {
  state = {
    ready: false,
    paymentMethod: 'stripe',
    renewQuota: 0,
    newQuota: 0,
    minQuota: 0
  }

  componentDidMount () {
    const { company } = this.props
    const minQuota = Math.max(company.usedQuota, 20)
    const currentQuota = company.quota

    this.setState({
      invoiceEmail: company.adminEmail,
      renewQuota: currentQuota,
      minQuota
    })

    get(`admin/payment?type=renew&quota=${currentQuota}`).then(ret => {
      if (this.state.renewQuota !== currentQuota) {
        return
      }
      this.setState({
        remainingDays: ret.remainingDays,
        renewAmountCNY: ret.amountCNY,
        renewAmountUSD: ret.amountUSD
      })
    })

    const delay = getQueryVariable('delay')
    if (delay) {
      setTimeout(() => {
        this.setState({ ready: true })
      }, Number(delay) * 1000)
    } else {
      this.setState({ ready: true })
    }
  }

  openStripe = ({ description, amount, tokenCallback, closedCallback }) => {
    const handler = StripeCheckout.configure({
      key: 'pk_live_qE5hyWrgfn75XQdEdvPKqGLq',
      image: 'https://nssurge.com/img/stripe-icon.png',
      locale: 'auto',
      email: this.props.company.adminEmail,
      token: tokenCallback,
      closed: closedCallback
    })
    handler.open({
      name: 'Surge',
      description: description || 'Surge Enterprise',
      amount: amount * 100
    })
  }

  renderPrice (add = true) {
    const key = add ? 'addQuotaAmount' : 'renewAmount'
    if (this.state.paymentMethod === 'stripe' && this.state[key + 'USD']) {
      return `USD $${this.state[key + 'USD']}`
    }
    if (this.state.paymentMethod === 'alipay' && this.state[key + 'CNY']) {
      return `RMB ￥${this.state[key + 'CNY']}`
    }
    return null
  }

  renderEnhance () {
    return (
      <Modal
        open={Boolean(this.state.enhanceShow)}
        onClose={() => this.setState({ enhanceShow: false })}
        title='Add Device Quota'
        footer={[
          <Button key='cancel' variant='ghost' onClick={() => this.setState({ enhanceShow: false })}>Cancel</Button>,
          <Button
            key='continue'
            disabled={!this.state.addQuotaAmountUSD}
            onClick={() => {
              this.setState({ quotaPaying: true })
              if (this.state.paymentMethod === 'stripe') {
                this.openStripe({
                  amount: this.state.addQuotaAmountUSD,
                  description: 'Surge Enterprise',
                  tokenCallback: token => {
                    post('admin/payment', {
                      type: 'add-quota',
                      stripeToken: token.id,
                      channel: 'stripe',
                      quota: this.state.newQuota + this.props.company.quota
                    })
                      .then(ret => {
                        if (ret.error) {
                          alert(`Payment failed: ${ret.error}`)
                        }
                        window.location.reload()
                      })
                      .catch(e => {
                        alert(`Payment failed: ${e.message}`)
                        window.location.reload()
                      })
                  },
                  closedCallback: () => {
                    this.setState({ quotaPaying: false })
                  }
                })
              }
            }}
          >
            Continue
          </Button>
        ]}
      >
        <div className='space-y-4'>
          <div className='flex items-center justify-between text-sm text-slate-600'>
            <span>Current Quota</span>
            <span className='font-semibold text-ink'>{this.props.company.quota}</span>
          </div>
          <label className='block'>
            <span className='text-sm font-medium text-slate-600'>Buy Extra Quota</span>
            <input
              type='number'
              className='mt-1 w-full rounded-xl border border-slate-200 px-3 py-2 focus:border-ink focus:ring-1 focus:ring-ink'
              value={this.state.newQuota || ''}
              onChange={e => {
                const value = Math.max(Number(e.target.value) || 0, 0)
                const total = value + this.props.company.quota
                this.setState(
                  { newQuota: value, addQuotaAmountCNY: null, addQuotaAmountUSD: null },
                  () => {
                    if (this.state.newQuota !== value) return
                    get(`admin/payment?type=add-quota&quota=${total}`).then(ret => {
                      if (this.state.newQuota !== value) return
                      this.setState({
                        remainingDays: ret.remainingDays,
                        addQuotaAmountCNY: ret.amountCNY,
                        addQuotaAmountUSD: ret.amountUSD
                      })
                    })
                  }
                )
              }}
            />
          </label>
          <div className='flex items-center justify-between text-sm text-slate-600'>
            <span>New Quota</span>
            <span className='font-semibold text-ink'>
              {this.props.company.quota + (this.state.newQuota || 0)}
            </span>
          </div>
          <div className='flex items-center justify-between text-sm text-slate-600'>
            <span>Payment</span>
            <span>{this.renderPrice(true)}</span>
          </div>
        </div>
      </Modal>
    )
  }

  renderRenew () {
    return (
      <Modal
        open={Boolean(this.state.renewShow)}
        onClose={() => this.setState({ renewShow: false })}
        title='Renew Subscription'
        footer={[
          <Button key='cancel' variant='ghost' onClick={() => this.setState({ renewShow: false })}>Cancel</Button>,
          <Button
            key='continue'
            disabled={!this.state.renewAmountUSD}
            onClick={() => {
              this.setState({ paying: true })
              if (this.state.paymentMethod === 'stripe') {
                this.openStripe({
                  amount: this.state.renewAmountUSD,
                  description: 'Surge Enterprise',
                  tokenCallback: token => {
                    post('admin/payment', {
                      type: 'renew',
                      channel: 'stripe',
                      stripeToken: token.id,
                      quota: this.state.renewQuota
                    })
                      .then(ret => {
                        if (ret.error) {
                          alert(`Payment failed: ${ret.error}`)
                        }
                        window.location.reload()
                      })
                      .catch(e => {
                        alert(`Payment failed: ${e.message}`)
                        window.location.reload()
                      })
                  },
                  closedCallback: () => {
                    this.setState({ paying: false })
                  }
                })
              }
            }}
          >
            Continue
          </Button>
        ]}
      >
        <div className='space-y-4'>
          <label className='block'>
            <span className='text-sm font-medium text-slate-600'>Device Quota</span>
            <input
              type='number'
              className='mt-1 w-full rounded-xl border border-slate-200 px-3 py-2 focus:border-ink focus:ring-1 focus:ring-ink'
              value={this.state.renewQuota || ''}
              min={this.state.minQuota}
              onChange={e => {
                let total = Number(e.target.value) || 0
                if (total < this.state.minQuota) {
                  alert(`The quota must be greater than ${this.state.minQuota}.`)
                  total = this.state.minQuota
                }
                this.setState(
                  { renewQuota: total, renewAmountCNY: null, renewAmountUSD: null },
                  () => {
                    if (this.state.renewQuota !== total) return
                    get(`admin/payment?type=renew&quota=${total}`).then(ret => {
                      if (this.state.renewQuota !== total) return
                      this.setState({
                        remainingDays: ret.remainingDays,
                        renewAmountCNY: ret.amountCNY,
                        renewAmountUSD: ret.amountUSD
                      })
                    })
                  }
                )
              }}
            />
          </label>
          <div className='flex items-center justify-between text-sm text-slate-600'>
            <span>Expiration Date</span>
            <span>{moment(this.props.company.expiredDate).format('MMM D, YYYY')}</span>
          </div>
          <div className='flex items-center justify-between text-sm text-slate-600'>
            <span>Extend To</span>
            <span>
              {moment(this.props.company.expiredDate)
                .add(1, 'year')
                .format('MMM D, YYYY')}
            </span>
          </div>
          <div className='flex items-center justify-between text-sm text-slate-600'>
            <span>Payment</span>
            <span>{this.renderPrice(false)}</span>
          </div>
        </div>
      </Modal>
    )
  }

  render () {
    if (!this.state.ready) {
      return (
        <div className='flex items-center justify-center py-20 text-slate-500'>Preparing dashboard…</div>
      )
    }

    const threshold = 35 * 24 * 3600 * 1000
    const remain = new Date(this.props.company.expiredDate) - new Date()
    const expired = remain <= 0
    const remainDays = Math.max(Math.floor(remain / (1000 * 60 * 60 * 24)), 0)
    const usage = this.props.company.quota
      ? (this.props.company.usedQuota / this.props.company.quota) * 100
      : 0

    return (
      <div className='space-y-6'>
        {this.renderRenew()}
        {this.renderEnhance()}

        <Panel className='bg-gradient-to-br from-slate-900 to-indigo-950 text-white border-none shadow-[0_20px_30px_rgba(15,23,42,0.35)]'>
          <div className='space-y-4'>
            <p className='uppercase tracking-[0.3em] text-xs text-white/70'>Dashboard</p>
            <h1 className='text-3xl md:text-4xl font-semibold'>Welcome back, {this.props.company.adminEmail}</h1>
            <p className='text-white/80 max-w-2xl'>
              Track your license health, onboard users, and keep every device in sync with your unified profile from a refreshed command center.
            </p>
            <div className='flex flex-wrap gap-3'>
              <Button onClick={() => this.setState({ renewShow: true })}>Renew Plan</Button>
              <Button variant='subtle' onClick={() => this.setState({ enhanceShow: true })}>
                Add Quota
              </Button>
            </div>
          </div>
        </Panel>

        {(expired || remain < threshold) && (
          <div className='rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 flex items-center justify-between'>
            <span>
              {expired
                ? 'Your subscription has expired. Renew now to keep devices connected.'
                : `Your subscription will end in ${remainDays} days.`}
            </span>
            <Button variant='primary' className='px-3 py-1 text-xs' onClick={() => this.setState({ renewShow: true })}>Renew</Button>
          </div>
        )}

        <div className='grid gap-5 md:grid-cols-2'>
          <Panel>
            <div className='flex items-center justify-between mb-6'>
              <div>
                <h2 className='text-lg font-semibold text-ink'>License Status</h2>
                <p className='text-sm text-slate-500 mt-1'>Quota usage overview</p>
              </div>
              {remain > 3600 * 1000 && (
                <Button variant='subtle' className='px-3 py-2 text-xs' onClick={() => this.setState({ enhanceShow: true })}>
                  Add Quota
                </Button>
              )}
            </div>
            <div className='space-y-4'>
              <div>
                <p className='text-sm text-slate-500'>Quota Usage</p>
                <p className='text-2xl font-semibold text-ink'>
                  {this.props.company.usedQuota} / {this.props.company.quota}
                </p>
                <div className='mt-2 h-2 w-full rounded-full bg-slate-100'>
                  <div className='h-full rounded-full bg-blue-500' style={{ width: `${Math.min(100, Math.round(usage))}%` }} />
                </div>
              </div>
              <div className='grid grid-cols-2 text-sm text-slate-600'>
                <div>
                  <p>Expires</p>
                  <p className='font-semibold text-ink'>
                    {moment(this.props.company.expiredDate).format('MMM D, YYYY')}
                  </p>
                </div>
                <div>
                  <p>Remaining Days</p>
                  <p className='font-semibold text-ink'>{remainDays}</p>
                </div>
              </div>
            </div>
          </Panel>

          <Panel>
            <h2 className='text-lg font-semibold text-ink mb-4'>Getting Started</h2>
            <ol className='list-decimal pl-5 space-y-3 text-sm text-slate-600'>
              <li>
                Create new users in the{' '}
                <button className='text-blue-600 underline' onClick={() => this.props.history.push('/dashboard/users')}>
                  Users
                </button>{' '}
                tab and assign device quota effortlessly.
              </li>
              <li>
                Configure a unified profile once and deliver it everywhere from the{' '}
                <button className='text-blue-600 underline' onClick={() => this.props.history.push('/dashboard/unified-profile')}>
                  Unified Profile
                </button>{' '}
                workspace.
              </li>
              <li>Invite employees to download the apps and follow the installation guide below.</li>
              <li>
                Share the onboarding link:{' '}
                <a className='text-blue-600 underline' href='https://enterprise.nssurge.com/install' target='_blank' rel='noopener noreferrer'>
                  https://enterprise.nssurge.com/install
                </a>
              </li>
            </ol>
            <p className='text-sm text-slate-500 mt-4'>
              For any questions, reach out to{' '}
              <a className='text-blue-600' href='mailto:enterprise@nssurge.com'>enterprise@nssurge.com</a>.
            </p>
          </Panel>
        </div>

        <Panel>
          <h2 className='text-lg font-semibold text-ink mb-4'>Install Guide</h2>
          <InstallGuide />
        </Panel>
      </div>
    )
  }
}

export default Landing
